import { RootState } from 'editor/src/store';

/**
 * Print-area token for a spread whose name doesn't match the catalogue scene
 * names (AOP spreads are named '1','2','3' while /scenes/editor entries are
 * named by area, e.g. 'front'). Resolved through the live-preview ordering
 * invariant: spreads[i] prints areaTokens[i]. Returns undefined for products
 * without live-preview tokens, so name-matched products are never affected.
 * Stopgap until preflight names AOP spreads by area.
 */
const getAreaTokenForSpreadName = (state: RootState, spreadName: string | undefined | null): string | undefined => {
  const tokens = state.livePreview.areaTokens;
  const spreads = state.design.designData?.spreads;
  if (!spreadName || !tokens.length || !spreads || spreads.length !== tokens.length) {
    return undefined;
  }
  const index = spreads.findIndex((spread) => spread.name === spreadName);
  const token = index >= 0 ? tokens[index] : undefined;
  return token !== spreadName ? token : undefined;
};

export default getAreaTokenForSpreadName;
